export enum ToolbarDropdownType {
  BRAND_STYLE = 'brand-style',
  FONT_FAMILY = 'font-family',
  TEXT_ALIGN_HORIZONTAL = 'text-align-horizontal',
}
